import KoruLogo from './KoruLogo';
import { KoruLogoProps, KoruLogoValueProps } from './types';

export type { KoruLogoProps, KoruLogoValueProps };
export default KoruLogo;
